export enum LocationKinds {
	CITY = 'CT',
	COUNTRY = 'CR',
	REGION = 'RG',
}
